import React, { useState } from 'react';
import { FaSearch, FaUserAlt, FaHeart, FaShoppingBag, FaChevronDown, FaBars } from 'react-icons/fa'; // Importing icons from react-icons
import { Logo } from 'src/assets/images';
import Modal from './modal/Modal';
import CartModal from './modal/CartModal';

const Navbar = () => {
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [mobileMenuVisible, setMobileMenuVisible] = useState(false);
    const [isAddQueryModalOpen, setIsAddQueryModalOpen] = useState(false);

    return (
        <div>
            <nav className="bg-white shadow-md py-4">
                <div className="container mx-auto flex justify-between items-center my-2">
                    {/* Left part - Links */}
                    <div className="flex space-x-6 relative flex-1">
                        <div
                            className="relative text-lg font-semibold cursor-pointer flex items-center the-link-fatix"
                            onMouseEnter={() => setDropdownVisible(true)}
                            onMouseLeave={() => setTimeout(() => setDropdownVisible(false), 300)}
                        >
                            {/* <a href='/shop'>Shop</a> */}
                            {/* <FaChevronDown className="ml-2 text-gray-600" /> */}
                            {/* Dropdown Menu */}
                            {/* {dropdownVisible && (
                                <div className="absolute left-0 top-4 mt-2 w-[70vw]  bg-white shadow-lg rounded z-10 p-6">
                                    <div className="grid grid-cols-3 gap-4 mobile-shop-option">
                                        <div>
                                            <h3 className='fatix-link-cat-heading mobile-shop-pin-sub'><b>All Product</b></h3>
                                            <a href="1" className="block  py-2 text-gray-700 hover:bg-gray-100 mobile-shop-pin">New Arrivals</a>
                                            <a href="1" className="block  py-2 text-gray-700 hover:bg-gray-100 mobile-shop-pin">Lace</a>
                                            <a href="1" className="block  py-2 text-gray-700 hover:bg-gray-100 mobile-shop-pin">Ankara</a>
                                            <a href="1" className="block  py-2 text-gray-700 hover:bg-gray-100 mobile-shop-pin">Materials</a>
                                            <a href="1" className="block  py-2 text-gray-700 hover:bg-gray-100 mobile-shop-pin">Gele</a>
                                        </div>
                                        <div>
                                            <h3 className='fatix-link-cat-heading mobile-shop-pin-sub'><b>Categories</b></h3>
                                            <a href="1" className="block  py-2 text-gray-700 hover:bg-gray-100 mobile-shop-pin">Fatix high target</a>
                                            <a href="1" className="block  py-2 text-gray-700 hover:bg-gray-100 mobile-shop-pin">Fatix java</a>
                                            <a href="1" className="block  py-2 text-gray-700 hover:bg-gray-100 mobile-shop-pin">Fatix glamour</a>
                                            <a href="1" className="block  py-2 text-gray-700 hover:bg-gray-100 mobile-shop-pin">Fatix gold perfect</a>
                                            <a href="1" className="block  py-2 text-gray-700 hover:bg-gray-100 mobile-shop-pin">Fatix executive </a>
                                            <a href="1" className="block  py-2 text-gray-700 hover:bg-gray-100 mobile-shop-pin">Fatix blue perfect</a>
                                            <a href="1" className="block  py-2 text-gray-700 hover:bg-gray-100 mobile-shop-pin">JB wax and ultimate</a>
                                        </div>
                                        <div>
                                            <h3 className='fatix-link-cat-heading mobile-shop-pin-sub'><b>Services</b></h3>
                                            <a href="1" className="block  py-2 text-gray-700 hover:bg-gray-100 mobile-shop-pin">Retail</a>
                                            <a href="1" className="block  py-2 text-gray-700 hover:bg-gray-100 mobile-shop-pin">Wholesales</a>
                                            <a href="1" className="block  py-2 text-gray-700 hover:bg-gray-100 mobile-shop-pin">Ceremonial contract sales</a>
                                        </div>
                                    </div>
                                </div>
                            )} */}
                        </div>
                        <a href="/about" className="text-lg font-semibold hidden md:block  the-link-fatix" >About</a>
                        <a href="/contact" className="text-lg font-semibold hidden md:block the-link-fatix">Contact Us</a>
                        <a href="/gallery" className="text-lg font-semibold hidden md:block the-link-fatix">Gallery</a>
                    </div>

                    <div className="flex justify-center flex-1">
                        <a href='/'> <img src={Logo} alt='' className='logo-on-mobile' /></a>
                    </div>

                    {/* Right part - Currency and Icons */}
                    <div className="flex items-center space-x-6 flex-1 justify-end">
                        <span className="text-lg font-semibold text-gray-800 hidden md:block the-link-fatix">NGN</span>
                        <a href='/shop'><FaSearch className="the-link-fatix text-xl text-gray-600 cursor-pointer hidden md:block" /></a>
                        <a href='/account'><FaUserAlt className="the-link-fatix text-xl text-gray-600 cursor-pointer hidden md:block" /></a>
                        <a href='/wishlist'><FaHeart className="the-link-fatix text-xl text-gray-600 cursor-pointer hidden md:block" /></a>
                        <div onClick={() => {
                            setIsAddQueryModalOpen(true)
                        }} ><FaShoppingBag className="the-link-fatix text-xl text-gray-600 cursor-pointer hidden md:block" /></div>
                        {/* Mobile toggle icon */}
                        <div className="md:hidden">
                            <FaBars
                                className="text-2xl text-gray-600 cursor-pointer"
                                onClick={() => setMobileMenuVisible(!mobileMenuVisible)}
                            />
                        </div>
                    </div>
                </div>

                {/* Mobile Menu */}
                {mobileMenuVisible && (
                    <div className="md:hidden bg-white shadow-md py-4 footer-navigation-content">
                        <div className="flex flex-col items-center space-y-4">
                            <a href="/about" className="text-lg font-semibold">About</a>
                            <a href="/contact" className="text-lg font-semibold">Contact Us</a>
                            <a href="/gallery" className="text-lg font-semibold">Gallery</a>
                            <a href="/shop" className="text-lg font-semibold">Shop</a>
                            <a href="/account" className="text-lg font-semibold">Account</a>
                            <a href="/wishlist" className="text-lg font-semibold">Wishlist</a>
                        </div>
                    </div>

                )}
            </nav>
            <Modal isOpen={isAddQueryModalOpen} setIsOpen={setIsAddQueryModalOpen} title="Item Added to your cart" size="sm">
                <CartModal setIsOpen={setIsAddQueryModalOpen} />
            </Modal>
        </div>

    );
};

export default Navbar;
